module.exports = __webpack_public_path__ + "assets/2@2x.6eebac25.png";